import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chart } from 'react-chartjs-2';
import { useState } from 'react';
import { Box, Card, Typography, Stack, } from '@mui/material';
import GroupBySelect from '../GroupBySelect';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, LineController, Legend, BarController, } from 'chart.js';
import PieChartLegend from '../SpendReport/PieChart/PieChartLegend';
import { getFilteredAnalyticsData, } from '../utils/getFilteredAnalyticsData';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement, LineController, BarController);
let ranges = [
    { divider: 1e6, suffix: 'M' },
    { divider: 1e3, suffix: 'k' },
];
function formatNumber(n) {
    for (var i = 0; i < ranges.length; i++) {
        if (n >= ranges[i].divider) {
            return (n / ranges[i].divider).toString() + ranges[i].suffix;
        }
    }
    return n;
}
const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
    },
    scales: {
        spend: {
            type: 'linear',
            display: true,
            position: 'right',
            ticks: {
                callback(tickValue, index, ticks) {
                    return formatNumber(tickValue);
                },
            },
            title: {
                display: true,
                text: 'Spend',
            },
        },
        impression: {
            type: 'linear',
            display: true,
            position: 'left',
            grid: {
                display: false,
            },
            ticks: {
                callback(tickValue) {
                    return formatNumber(tickValue);
                },
            },
            title: {
                display: true,
                text: 'Impression',
            },
        },
        x: {
            grid: {
                display: false,
            },
            ticks: {
                display: true,
                callback(tickValue, index, ticks) {
                    return this.getLabelForValue(index).split(' ')[0];
                },
            },
        },
    },
};
const legends = [
    {
        label: 'Impression',
        color: '#9B51E0',
    },
    {
        label: 'Spend',
        color: '#FD8F77',
    },
];
export default function ImpressionVsSpendChart({ data }) {
    const [selectedOption, setSelectedOption] = useState('mediaOption');
    const [filteredData, setFilteredData] = useState(getFilteredAnalyticsData(data, selectedOption));
    const handleSelectedOption = (value) => {
        setSelectedOption(value);
        setFilteredData(getFilteredAnalyticsData(data, value));
    };
    const labels = filteredData
        .slice(0, 10)
        .map((i) => selectedOption === 'mediaOption'
        ? `${i.mediaOption} on ${i.media}`
        : i.toolName);
    const chartData = {
        labels,
        datasets: [
            {
                label: 'Spend',
                type: 'line',
                data: filteredData.slice(0, 10).map((i) => i.spend),
                backgroundColor: '#FD8F77',
                borderColor: '#FD8F77',
                borderWidth: 2,
                yAxisID: 'spend',
            },
            {
                label: 'Impression',
                data: filteredData.slice(0, 10).map((i) => i.impressions),
                backgroundColor: '#9B51E0',
                yAxisID: 'impression',
                maxBarThickness: 30,
            },
        ],
    };
    return (_jsxs(Card, Object.assign({ sx: { p: '16px 16px 24px 16px' } }, { children: [_jsxs(Box, Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center", mb: "30px" }, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "Impression vs Spend Report" })), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 3 }, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: "Filter by" })), _jsx(GroupBySelect, { onSelect: handleSelectedOption, selected: selectedOption })] }))] })), _jsx(Chart, { type: "bar", options: options, data: chartData }), _jsx(Box, Object.assign({ display: "flex", justifyContent: "center", mt: "24px" }, { children: legends.map((legend) => (_jsx(Box, Object.assign({ color: legend.color, mr: "16px" }, { children: _jsx(PieChartLegend, { label: legend.label, legendColor: legend.color }) }), legend.label))) }))] })));
}
